import { Fragment } from 'react'

import { AccountNumber } from '@/modules/projects/components/Workbench/AccountNumber'
import type { Account } from '@/modules/projects/components/Workbench/types'

// Each number stays on one line, so the list wraps between accounts, never inside one.
export const CombinedNote = ({ account }: { account: Account }) => (
  <p className="px-2 py-1.5 text-xs leading-5 text-ink-subtle">
    This is a combined statement: the bank printed{' '}
    {account.numbers.map((number, index) => (
      <Fragment key={number}>
        {index === 0
          ? ''
          : index === account.numbers.length - 1
            ? ' and '
            : ', '}
        <AccountNumber
          numbers={[number]}
          className="whitespace-nowrap text-foreground"
        />
      </Fragment>
    ))}{' '}
    on it together. It can't be filed under just one of them.
  </p>
)
